import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'

const ACCEPTED_FILE_TYPES = "image/png, image/jpeg, application/pdf"

JobWizardMobile.AddAttachment = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion, onStepRetreat) {
    if (Job.Data.backToSubmit === true){
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.JobSummary)
    }
    else {
      onStepProgression()
    }
  },

  onLeftNavButtonClick(onStepProgression) {
    if (SS.currentUserId !== null && typeof SS.currentUserId !== "undefined") {
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.CanCall)
    }
    else {
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.GetContact)
    }
  },

  component: React.createClass({
    getInitialState: function() {
      return {
        fileNames: [],
        fileErrors: ""
      }
    },

    handleFiles: function(e) {
      var result = processFiles()

      this.setState({fileErrors: ""})

      this.setState({
        fileNames: this.state.fileNames.concat(result['fileNames'])
      })

      if (result['rejectedFiles']){
        this.setState({fileErrors: "One or more files you selected are unsupported. Please select .pdf, .jpg, .jpeg, or .png image files."})
      }

      function processFiles() {
        let result = {}
        let fileNames = []

        // DOESN'T work in ios // for(let file of e.target.files) {
        // DOESN'T work in ios //   actions.uploadFiles(file)
        // DOESN'T work in ios //   fileNames.push(file.name)
        // DOESN'T work in ios // }
        // https://developer.mozilla.org/en/docs/Web/API/FileList

        var files = e.target.files;
        var fl = files.length;
        var file;

        for (var i = 0; i < fl; i++) {
            file = files[i];
            if (fileTypeIsSupported(file)) {
              Job.Actions.uploadFiles(file)
              Job.Actions.updateFileNames(file.name)
              fileNames.push(file.name)
            } else {
              result['rejectedFiles'] = true
            }
        }

        result['fileNames'] = fileNames
        return result
      }

      function fileTypeIsSupported(file) {
        var validExtensions  = ['jpg', 'jpeg', 'png', 'pdf']
        var fileExtension = file.name.split('.').pop().toLowerCase()
        
        return validExtensions.indexOf(fileExtension) > -1
      }
    },

    renderImageFileNames: function() {
      return (
        Job.Data.fileNames.map(function (name) {
          return (
            <span key={name}>
              <p>{name}</p>
            </span>
          )
        })
      )
    },

    render: function() {
      return(
        <div>
          <h3 className="mb5 mt10">Upload photos to help further explain your job.</h3>
          {
            Job.Data.fileNames.length == 0 ?
              <div>
                <div className='mt20 input-group'>
                  <span>
                    <JobWizardMobile.UploadFile handleFiles={this.handleFiles} 
                      id={'job-description-fileupload'}
                      accept={ACCEPTED_FILE_TYPES}
                      buttonClass="btn btn-secondary btn-block"
                      labelTitle="Choose File"
                    />
                  </span>
                  <span className="input-group-btn pl20">
                    <JobWizardMobile.NavigationButtons
                      navButtonLayout='skipButton'
                      onStepProgression={this.props.onStepProgression}
                    />
                  </span>
                </div>
                <div className='text-red'>
                  { this.state.fileErrors }
                </div>
              </div>
            :
              <div>
                <div className='mt20'>
                  <div className='mt5' style={{'overflowX': 'hidden', 'overflowY': 'scroll'}}>
                    { this.renderImageFileNames() }
                  </div>
                  <JobWizardMobile.UploadFile handleFiles={this.handleFiles} 
                    id={'job-description-fileupload'}
                    accept={ACCEPTED_FILE_TYPES}
                    buttonClass="btn btn-block btn-default"
                    labelTitle="Add More"
                  />
                  <div className="pull-right pt10">
                    <JobWizardMobile.NavigationButtons
                      navButtonLayout='okButton'
                      onStepProgression={this.props.onStepProgression}
                    />
                  </div>      
                </div>
                <div className='text-red'>
                  { this.state.fileErrors }
                </div>
              </div>
          }
        </div>
      )
    }
  })
}
